var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1176 14.2353V5.76471C32.1176 3.68552 30.4321 2 28.3529 2H5.76471C3.68552 2 2 3.68552 2 5.76471V20.4962C2 22.5754 3.68552 24.2609 5.76471 24.2609H8.711V32.1176L16.5678 24.2609H17.0588M26.7775 29.0895L31.688 34V29.0895H32.1176C34.1968 29.0895 35.8824 27.404 35.8824 25.3248V18.9412C35.8824 16.862 34.1968 15.1765 32.1176 15.1765H20.8235C18.7443 15.1765 17.0588 16.862 17.0588 18.9412V25.3248C17.0588 27.404 18.7443 29.0895 20.8235 29.0895H26.7775Z",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineChatIcon);
export default __webpack_public_path__ + "static/media/online-chat-icon.e73a0e97f9fbe400f22b83e1d6abba4c.svg";
export { ForwardRef as ReactComponent };